module.exports = __webpack_public_path__ + "static/img/LiveRamp-Selected.1251bcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/LiveRamp-Selected.png
// module id = 747
// module chunks = 0